export default __webpack_public_path__ + "static/media/services.8f5a67c0.jpg";